var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "new_home_div"
  }, [false ? _c('div', [_c('img', {
    attrs: {
      "src": "https://image.kilimall.com/seller/bj_zfblh_x2.jpg",
      "fluid": "",
      "alt": "Responsive image"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    class: [_vm.$style.branner_div]
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.img_url.branner,
      "alt": "Responsive image"
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.$style.pay_branner_div]
  }), _vm._v(" "), _c('div', {
    class: [_vm.$style.branner_div_content]
  }, [_c('div', {
    staticClass: "branner_div_title",
    class: [_vm.$style.branner_div_title]
  }, [_vm._v("\n          " + _vm._s(_vm.$t('home.bannerTitle')) + "\n        ")]), _vm._v(" "), _c('div', {
    class: [_vm.$style.branner_div_desc]
  }, [_vm._v("\n          " + _vm._s(_vm.$t('home.bannerSubtitle')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "branner_div_button_div",
    class: [_vm.$style.branner_div_button_div]
  }, [_c('div', {
    class: [_vm.$style.branner_play_button],
    on: {
      "click": _vm.fn_register
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('home.registerNow')) + "\n          ")])])]), _vm._v(" "), false ? _c('div', {
    class: [_vm.$style.vedio_btn_div],
    on: {
      "click": _vm.pay_vedio_fn
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.is_vedio_play,
      expression: "is_vedio_play"
    }],
    class: [_vm.$style.vedio_pay_item]
  }, [_c('video', {
    staticClass: "video-js",
    attrs: {
      "id": _vm.vedio_id
    }
  }, [_c('source', {
    attrs: {
      "src": "https://image.kilimall.cn/kilimall.mp4",
      "type": "video/mp4"
    }
  })])]), _vm._v(" "), _c('img', {
    class: [_vm.$style.vedio_btn_img],
    attrs: {
      "src": _vm.img_url.vedio
    },
    on: {
      "click": _vm.vedioPauseClick
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "map_div",
    class: [_vm.$style.map_div]
  }, [_c('div', {
    class: [_vm.$style.map_h1_title]
  }, [_vm._v("\n      " + _vm._s(_vm.$t('home.market')) + "\n    ")]), _vm._v(" "), _c('img', {
    class: [_vm.$style.map_img],
    attrs: {
      "src": _vm.img_url.map
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.$style.map_desc_div]
  }, [_c('div', {
    staticClass: "map_content_one",
    class: [_vm.$style.map_content, _vm.$style.map_content_one]
  }, [_c('div', {
    class: [_vm.$style.map_title]
  }, [_vm._v("\n          " + _vm._s(_vm.$t('home.consumer')) + "\n        ")]), _vm._v(" "), _c('div', {
    class: [_vm.$style.map_info_div]
  }, [_c('div', {
    staticClass: "map-introduce"
  }, [_c('div', {
    staticClass: "introduce-item"
  }, [_c('div', {
    class: [_vm.$style.map_number_color]
  }, [_vm._v("\n                " + _vm._s(_vm.$t('home.internet')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "introduce-text"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('home.internetUser')) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce-item"
  }, [_c('div', {
    class: [_vm.$style.map_number_color]
  }, [_vm._v("\n                " + _vm._s(_vm.$t('home.dollars')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "introduce-text width-en"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('home.dollarsShare')) + "\n              ")])])])]), _vm._v(" "), _c('p', {
    class: [_vm.$style.map_desc]
  }, [_vm._v("\n          " + _vm._s(_vm.$t('home.marketIntroduce')) + "\n        ")])]), _vm._v(" "), _c('div', {
    class: [_vm.$style.clear_fix_div]
  }), _vm._v(" "), _c('div', {
    staticClass: "map_content_two",
    class: [_vm.$style.map_content, _vm.$style.map_content_two]
  }, [_c('div', {
    class: [_vm.$style.map_title]
  }, [_vm._v("\n          " + _vm._s(_vm.$t('home.platform')) + "\n        ")]), _vm._v(" "), _c('div', {
    class: [_vm.$style.map_info_div, _vm.$style.map_info_max_width]
  }, [_c('div', {
    staticClass: "map-introduce"
  }, [_c('div', {
    staticClass: "introduce-item width-2"
  }, [_c('div', {
    class: [_vm.$style.map_number_color]
  }, [_vm._v("\n                300%\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "introduce-text"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('home.monthlySales')) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce-item width-3"
  }, [_c('div', {
    class: [_vm.$style.map_number_color]
  }, [_vm._v("\n                60%\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "introduce-text"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('home.rate')) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce-item"
  }, [_c('div', {
    class: [_vm.$style.map_number_color]
  }, [_vm._v("\n                30USD\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "introduce-text",
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('home.orderAmount')) + "\n              ")])])])]), _vm._v(" "), _c('p', {
    class: [_vm.$style.map_desc]
  }, [_vm._v("\n          " + _vm._s(_vm.$t('home.development')) + "\n        ")])])])]), _vm._v(" "), _c('div', {
    class: [_vm.$style.superiority_div]
  }, [_c('div', {
    class: [_vm.$style.container]
  }, [_c('h3', {
    class: [_vm.$style.superiority_title]
  }, [_vm._v("\n        " + _vm._s(_vm.$t('home.advantage')) + "\n      ")]), _vm._v(" "), _c('div', {
    class: [_vm.$style.superiority_list]
  }, [_c('Row', _vm._l(_vm.superiority_datas, function (item, index) {
    return _c('Col', {
      key: index,
      class: [_vm.$style.padding_clear],
      attrs: {
        "span": "8"
      }
    }, [_c('div', {
      class: [_vm.$style.superiority_item],
      on: {
        "mousemove": function ($event) {
          _vm.superiority_mome_index = index;
        },
        "mouseout": function ($event) {
          _vm.superiority_mome_index = -1;
        }
      }
    }, [_c('img', {
      class: [_vm.$style.superiority_img],
      attrs: {
        "src": item.img_url
      }
    }), _vm._v(" "), _c('div', {
      class: [_vm.$style.superiority_item_info, _vm.superiority_mome_index === index ? _vm.$style.move_opacity : _vm.$style.default_opacity]
    }), _vm._v(" "), _c('div', {
      class: [_vm.$style.superiority_item_info]
    }, [_c('div', {
      class: [_vm.$style.superiority_item_info_desc]
    }, [_c('img', {
      class: [_vm.$style.superiority_icon_img],
      attrs: {
        "src": item.img_icon_url
      }
    }), _vm._v(" "), _c('div', {
      class: [_vm.$style.superiority_item_title]
    }, [_vm._v("\n                    " + _vm._s(_vm.$t(item.title)) + "\n                  ")]), _vm._v(" "), _c('p', {
      class: [_vm.$style.superiority_item_info_p]
    }, [_vm._v("\n                    " + _vm._s(_vm.$t(item.desc)) + "\n                  ")])])])])]);
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    class: [_vm.$style.honor_div]
  }, [_c('div', {
    class: [_vm.$style.container]
  }, [_c('h3', {
    class: [_vm.$style.container_title]
  }, [_vm._v("\n        " + _vm._s(_vm.$t('home.join')) + "\n      ")]), _vm._v(" "), _c('div', {
    class: [_vm.$style.step_div]
  }, [_c('Row', {
    staticClass: "justify-content-md-center"
  }, _vm._l(_vm.step_datas, function (item, index) {
    return _c('Col', {
      key: index,
      class: [_vm.$style.step_margin],
      attrs: {
        "span": "6"
      }
    }, [_c('div', {
      class: [_vm.$style.step_item]
    }, [_c('span', {
      class: [_vm.$style.step_icon]
    }, [_vm._v(_vm._s(item.index))]), _vm._v(" "), _c('div', {
      class: [_vm.$style.step_title]
    }, [_vm._v("\n                " + _vm._s(_vm.$t(item.title)) + "\n              ")]), _vm._v(" "), _c('div', {
      class: [_vm.$style.step_desc]
    }, [_vm._v("\n                " + _vm._s(_vm.$t(item.desc)) + "\n              ")])])]);
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    class: [_vm.$style.submit_container]
  }, [_c('div', {
    class: [_vm.$style.submit_div]
  }, [_c('div', {
    class: [_vm.$style.container_title, _vm.$style.color_white]
  }, [_vm._v("\n          " + _vm._s(_vm.$t('home.bottomTitle')) + "\n        ")]), _vm._v(" "), _c('div', {
    class: [_vm.$style.submit_btn],
    on: {
      "click": _vm.fn_register
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('home.registerNow')) + "\n        ")])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }